import React from "react";

const SSCityReg = ({ cityReg }) => {
    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th className="px-3">Name</th>
                        <th className="px-3">City</th>
                        <th className="px-3">Email Id</th>
                        <th className="px-3">Phone</th>
                        <th className="px-3">Backup Contact</th>
                        <th className="px-3">Original Compositions</th>
                        <th className="px-3">Past Achievements</th>
                        <th className="px-3">Instruments Used</th>
                    </tr>
                </thead>
                <tbody>
                    {cityReg.map((element) => {
                        console.log(element);
                        return (
                            <tr>
                                <td className="px-3">{element.name}</td>
                                <td className="px-3">{element.city}</td>
                                <td className="px-3">{element.email}</td>
                                <td className="px-3">
                                    {element.contactNumber}
                                </td>
                                <td className="px-3">
                                    {element.backupContact}
                                </td>
                                <td className="px-3">
                                    {element.linksForComposition}
                                </td>
                                <td className="px-3">
                                    {element.pastAchievements}
                                </td>
                                <td className="px-3">
                                    {element.instrumentsUsed}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <hr />
        </>
    );
};

export default SSCityReg;
